import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'tx-empty-can-answer',
    templateUrl: './empty-can-answer.component.html',
    styleUrls: ['./empty-can-answer.component.css']
  })
export class EmptyCanAnswerComponent implements OnInit {

  REPORT_CAN_START_CHECK_BUS = 213;
  _trnRsnIds: Array<Number>;
  

  constructor() {
  }

  ngOnInit() {
  }

  get trnRsnIds() {
    return this.trnRsnIds;
  }

  @Input()
  set trnRsnIds(trnRsnIds) {
    this._trnRsnIds = trnRsnIds;
  }

  hasReportCanStartCheckBusTrnRsn() {
    return this._trnRsnIds && this._trnRsnIds.includes(this.REPORT_CAN_START_CHECK_BUS);
  }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/empty-can-answer/empty-can-answer.component.ts